export default __webpack_public_path__ + "static/media/security-data.0ee651b1.jpg";